export function useApiIterable() {
  const { $api } = useNuxtApp();

  const sendUsersUpdateEvent = async (body, endpoint = 'update') => {
    try {
      return await $api.itapi(body, endpoint, 'POST');
    } catch (error) {
      console.error('failed to send a Users Update event to Iterable', error.message);
      return null;
    }
  };

  return { sendUsersUpdateEvent };
}
